/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'

import Menu from '../../../../components/CustomerClub/Menu'

import commentIcon from '../../../../assets/svg/Comment.svg'

import Table from '../../../../components/CustomerClub/CommentsList'
import { get } from '../../../../services/http'

import { notify } from '../../../../components/Toast'

function index() {
  document.title = 'لیست دیدگاه‌ها'

  const [comments, setComments] = useState()
  const [commentsCount, setCommentsCount] = useState()
  const [totalPage, setTotalPage] = useState()

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/cccomments?token=${token}`).then(response => {
      setComments(response.data.data.docs)
      setTotalPage(response.data.data.pages)
      setCommentsCount(response.data.data.total)
    })
    .then(error => {
      // notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }, [token])

  const handlePageClick = (event) => {
    get(`/api/admin/cccomments?page=${event.selected + 1}&token=${token}`)
    .then(response => {
      setComments(response.data.data.docs)
      setTotalPage(response.data.data.pages)
      setCommentsCount(response.data.data.total)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  return (
    <main id='panel'>
      <Menu page={'comments'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={commentIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                دیدگاه کاربران
              </div>
            </div>
            <div className="left">
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                تعداد کل‌دیدگاه ها
              </div>
              <div className="left">
                {commentsCount}
              </div>
            </div>

            <Table data={comments}/>
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}

export default index